import React, { Component } from 'react'
import { connect } from 'react-redux'
// import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import videoConnect, { apiHelpers
} from 'react-html5video'
// import ObjectDiff from 'Lib/ObjectDiff'
import { Loader } from 'semantic-ui-react'

import CanvasActions from 'Redux/CanvasRedux'
import VideoActions from 'Redux/VideoRedux'
import CommentActions from 'Redux/CommentRedux'

import Seek from './Seek/Seek'
import Time from './Time/Time'
import Volume from './Volume/Volume'
import PlayPause from './PlayPause/PlayPause'
import JumpFrame from './JumpFrame/JumpFrame'
import Resolution from './Resolution/Resolution'
// import Fullscreen from './Fullscreen/Fullscreen'
import ToolBar from './ToolBar/ToolBar'
import VideoHeader from './VideoHeader/VideoHeader'
import copy from './English'

import Canvas from './Canvas/Canvas'
import CommentStream from './CommentStream/CommentStream'
import CommentBox from './CommentBox/CommentBox'
import CaptureVideoImage from './CaptureVideoImage/CaptureVideoImage'

import 'react-html5video/dist/styles.css'
import styles from './VideoPlayerStyles'
import DebugConfig from 'Config/DebugConfig'

class CustomVideo extends Component {
  /**
   * Determines if the video has been auto played once or not on initial load.
   */
  autoplayed = false

  componentDidUpdate (prevProps) {
    if (this.props.currentComment !== prevProps.currentComment &&
        !isEmpty(this.props.currentComment)) {
      this.props.pauseVideo()
      this.props.setCurrentTime(Number(this.props.currentComment.time))
    }
    if (this.props.isDrawing !== prevProps.isDrawing &&
        this.props.isDrawing) {
      this.props.pauseVideo()
    }
    if (this.props.video.paused === false &&
        prevProps.video.paused === true) {
      this.props.canvasSetActive(false)
    }
    if (!DebugConfig.isDev && this.autoplayed === false
           && this.props.video.loading === false) {
      this.props.playVideo()
      this.autoplayed = true
    }
  }

  clearCanvasScreen = () => {
    if(!isEmpty(this.props.currentComment)) {
      this.props.commentsSetCurrent({})
    }
    if (this.props.isDrawing) {
      this.props.canvasClearPoints()
      this.props.canvasSetActive(false)
    }
  }

  render () {
    const {
      // copy,
      pauseVideo,
      onVersionChange,
      currentVideo,
      onResolutionClick,
      currentResolution,
      video,
      style,
      className,
      onSeekChange,
      onVolumeChange,
      onVolumeClick,
      onPlayPauseClick,
      onRewindClick,
      onForwardClick,
    } = this.props
    let src = currentVideo.sourceUrl
    if (currentVideo.sources.length > 0 && !isNaN(currentResolution)) {
      src = currentVideo.sources[currentResolution].locationUrl
    }
    return (
      <div className={className} style={style}>
        <VideoHeader videoTitle={this.props.currentVideo.title}
                     activeProject={this.props.activeProject} />
        <ToolBar video={video} onVersionChange={onVersionChange} />
        <div className={styles.component}>
          <Loader active={video.loading} />
          <video
            playsInline
            className={styles.video}
            crossOrigin='anonymous'
            key={video.id}
            src={src}>
          </video>
          <Canvas
            width={this.props.width} height={this.props.height}
            paused={video.paused}
            onPlayPause={onPlayPauseClick}
          />
        </div>
        <Seek
          ariaLabel={copy.seek}
          className={styles.seek}
          onChange={(e) => {
            onSeekChange(e)
            this.clearCanvasScreen()
          }}
          {...video} />
        <CommentStream
          duration={video.duration}
        />
        <div className={styles.controls}>
          <div className={styles.leftControls}>
            <PlayPause
              ariaLabelPlay={copy.play}
              ariaLabelPause={copy.pause}
              onClick={onPlayPauseClick}
              {...video} />
            <Time {...video} />
            <Volume
              onClick={onVolumeClick}
              onChange={onVolumeChange}
              ariaLabelMute={copy.mute}
              ariaLabelUnmute={copy.unmute}
              ariaLabelVolume={copy.volume}
              {...video} />
          </div>
          <div className={styles.middleControl}>
            <JumpFrame
              onRewindClick={(duration) => () => {
                onRewindClick(duration)
                this.clearCanvasScreen()
              }}
              onForwardClick={(duration) => () => {
                onForwardClick(duration)
                this.clearCanvasScreen()
              }}
            />
          </div>
          <div className={styles.rightControls}>
            {currentVideo.sources.length > 0 &&
              <Resolution
                align='right'
                ariaLabelResolution={copy.resolution}
                currentResolution={currentResolution}
                onClick={onResolutionClick} />
            }
            <CaptureVideoImage
              videoEl={this.props.videoEl}
              videoId={this.props.currentVideo.id}
              title={this.props.currentVideo.title}
              onFrameCapture={pauseVideo}
            />
              {/*<Fullscreen
                ariaLabel={copy.fullscreen}
                onClick={onFullscreenClick}
                {...video} />*/}
          </div>
        </div>
        <CommentBox
          time={video.currentTime}
          onStartTyping={pauseVideo}
          onPlayPause={onPlayPauseClick}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { readyState, networkState, error, ...restState } = state
  return {
    video: {
      readyState: readyState,
      networkState: networkState,
      error: error || networkState === 3,
      // TODO: This is not pretty. Doing device detection to remove
      // spinner on iOS devices for a quick and dirty win. We should see if
      // we can use the same readyState check safely across all browsers.
      loading: readyState < (/iPad|iPhone|iPod/.test(navigator.userAgent) ? 1 : 4),
      percentagePlayed: apiHelpers.getPercentagePlayed(restState),
      percentageBuffered: apiHelpers.getPercentageBuffered(restState),
      ...restState
    },
    children: ownProps.children
  }
}

const mapVideoElToProps = (videoEl, state, ownProps) => {
  return {
    width: videoEl && videoEl.offsetWidth,
    height: videoEl && videoEl.offsetHeight,
    videoEl,

    onFullscreenClick: () => apiHelpers.toggleFullscreen(videoEl.parentElement),
    onVolumeClick: () => apiHelpers.toggleMute(videoEl, state),
    onPlayPauseClick: () => apiHelpers.togglePause(videoEl, state),
    onVolumeChange: (e) => apiHelpers.setVolume(videoEl, state, e.target.value),
    onSeekChange: (e) => {
      if (videoEl && state.duration) {
        return apiHelpers.setCurrentTime(
          videoEl, state, e.target.value * state.duration / 100)
      }
    },

    pauseVideo: () => videoEl && videoEl.pause(),
    playVideo: () => videoEl && videoEl.play(),
    onRewindClick: (duration) => {
      const currentTime = videoEl ? videoEl.currentTime : 0
      let revisedTime = currentTime - duration
      if (revisedTime < 0) revisedTime = 0

      videoEl && videoEl.pause()
      apiHelpers.setCurrentTime(videoEl, state, revisedTime)
    },
    onForwardClick: (duration) => {
      const currentTime = videoEl ? videoEl.currentTime : 0
      let revisedTime = currentTime + duration
      if (revisedTime > state.duration) revisedTime = state.duration

      videoEl && videoEl.pause()
      apiHelpers.setCurrentTime(videoEl, state, revisedTime)
    },
    setCurrentTime: (value) => apiHelpers.setCurrentTime(videoEl, state, value),
    onCaptionsClick: () => apiHelpers.toggleTracks(state),
    onCaptionsItemClick: (track) => apiHelpers.showTrack(state, track)
  }
}

const mergeProps = (stateProps, videoElProps, ownProps) => {
  return Object.assign({}, stateProps, videoElProps, ownProps)
}

const mapStateToPropsRedux = (state, ownProps) => ({
  currentVideo: state.videos.currentVideo,
  currentResolution: state.videos.resolution,
  activeProject: state.selections.activeProject,
  currentComment: state.comments.currentComment,
  isDrawing: state.canvas.isDrawing
})

const mapDispatchToProps = (dispatch) => ({
  canvasSetActive: (enabled) => dispatch(CanvasActions.canvasSetActive(enabled)),
  canvasClearPoints: (enabled) => dispatch(CanvasActions.canvasClearPoints()),
  commentsSetCurrent: (comment) =>
    dispatch(CommentActions.commentsSetCurrent(comment)),
  onResolutionClick: (index) => () => {
    return dispatch(VideoActions.videosSetResolution(index))
  }
})

export default connect(mapStateToPropsRedux, mapDispatchToProps)(
  videoConnect(CustomVideo, mapStateToProps, mapVideoElToProps, mergeProps)
)



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/VideoPlayer.js